<template>
<div class="left-wrap">
            
            
            
            <div style="color:var(--theme-label);">
              <div class="watchlist-heading">
                <span>我的自选股票</span><StockSearch compact />
              </div>
              <nav class="market-tabs">
                <button v-for="i in availableTabs" :key="i.id" type="button" @click="selHeyueTypeClick(i.id)" :class="{ active: tabList2Idx === i.id }">{{ i.name }}</button>
              </nav>
              <div class="watchlist-columns headings">
                  <span>名称/代码</span><span>最新价</span><span>涨跌幅</span>
              </div>
              <div v-for="(i,idx) in zixuanList" @click="$emit('select', i)" class="watchlist-columns watchlist-row">
                  <span class="watchlist-identity" :title="i.name + ' [' + i.full_code + ']'"><span>{{ i.name }}</span><small>[{{ i.full_code }}]</small></span>
                  <span :title="price(i.last_px)">{{ price(i.last_px) }}</span>
                  <span :title="percent(i.px_change_rate)" :class="quoteTone(i.px_change_rate)">{{ percent(i.px_change_rate) }}</span>
              </div>
             


            </div>
        </div>
</template>
<script>
import { quotePercent, quotePrice } from '@/utils/quoteDisplay'
import { quoteTone } from '@/utils/quoteColors'
import StockSearch from '@/components/StockSearch.vue'
import { getStockQuotes } from '@/utils/stockQuotes'
import { optionalNewApi } from '@/utils/requestapis'
import { pollMarket } from '@/utils/marketRefresh'
import { refreshWatchlist } from '@/utils/workspaceQuotes'
import { marketEnabled } from '@/utils/systemConfig'
import { sharedStockRows } from '@/utils/stockQuoteFeed'
export default {
  computed: { zixuanList: { get() { return sharedStockRows(this.rowsSnapshot, 'cn') }, set(value) { this.rowsSnapshot = value } }, availableTabs() { return this.tabList2.filter(tab => marketEnabled(({10:'cn',11:'hk',12:'us',2:'index'})[tab.id])) } },
  name: 'ChinaStockWatchlist',
  components: { StockSearch },
  data: () => ({
    tabList2: [{ id: 10, name: '沪深' }, { id: 11, name: '港股' }, { id: 12, name: '美股' }, { id: 2, name: '股指' }],
    tabList2Idx: 10,
    zx_keys_str: '', zx_keys_arr: [], page: 1, limit: 20, rowsSnapshot: []
  }),
  mounted() {
            this.optionalList()
            this.stopQuotes = pollMarket(async () => {
              const rows = await refreshWatchlist(this.zixuanList, 'cn')
              if (this.disposed) return
              const updates = new Map(rows.map(item => [item.full_code, item]))
              this.zixuanList = this.zixuanList.map(item => updates.get(item.full_code) || item)
            }, 'cn')
  },
  beforeDestroy() { this.disposed = true; if (this.stopQuotes) this.stopQuotes() },
  methods: {
    price: quotePrice,
    percent: quotePercent,
    quoteTone,
          myparseFloat(val){
            if(val){
              return parseFloat(val).toFixed(2)
            }
            return 0
          },
          	// 获取自选股列表
            optionalList(){
              let type = this.tabList2Idx - 10
              let data = {
                page:this.page,
                limit:this.limit,
                type:type
              }
              optionalNewApi(data).then(res =>{ 
                if(!this.disposed && res && res.data){
                  this.zixuanList = this.zixuanList.concat(res.data)
                 
                  // if(res.data.data.length<this.page_size){
                  //   this.status = 'nomore'
                  // }else{
                  //   this.status = 'loadmore'
                  // }
                  this.last_page = res.data.last_page
                }
              })
            },
            getzixuanKeys(){
              var list = this.zixuanList
              var keys = []
              var arr = []
              for(let key in list){
                if(list[key].last_px == undefined){
                  this.zixuanList.splice(key, 1);
                }else{
                  var arr1 = list[key].full_code.split('.')
                  let code = arr1[0].toLowerCase()
                  let idx = list[key].code
                  if(arr1[0].indexOf('hk') > -1){
                    keys.push('s_r_' + code)
                  }else if(arr1[0].indexOf('us') > -1){
                    code = list[key].code
                    if(arr1.length > 1){
                      idx = idx + '.' + arr1[arr1.length-1]
                    }
                    keys.push('t_s_us' + code)
                  }else{
                    keys.push('s_' + code)
                  }
                  arr[idx] = key
                }
              }
              this.zx_keys_arr = arr
              this.zx_keys_str = keys.join(',')
            },
            getzixuanTencentData(){
              if(this.zx_keys_str){
                return getStockQuotes(this.zx_keys_str).then(quotes=>{
                      for(const arr of Object.values(quotes)){
                        if (!Array.isArray(arr) || arr.length < 6) continue;
                        if(this.zx_keys_arr[arr[2]] != undefined){
                          let idx = this.zx_keys_arr[arr[2]]
                          this.zixuanList[idx].last_px = this.myparseFloat(arr[3])
                          this.zixuanList[idx].px_change_rate = this.myparseFloat(arr[5])
                        }
                      }
                      this.$forceUpdate()
                }).catch(error => {
                  console.error('获取自选行情失败', error)
                })
                // uni.request({
                //   url: 'https://sqt.gtimg.cn/q='+this.zx_keys_str, //仅为示例，并非真实接口地址。
                //   success: (res) => {
                //     let data = res.data.split('=');
                //     for(let i=1;i<data.length;i++){
                //       let arr =  data[i].split('~');
                //       if(this.zx_keys_arr[arr[2]] != undefined){
                //         let idx = this.zx_keys_arr[arr[2]]
                //         this.zixuanList[idx].last_px = this.myparseFloat(arr[3])
                //         this.zixuanList[idx].px_change_rate = this.myparseFloat(arr[5])
                //       }
                //     }
                //     this.$forceUpdate()
                //   }
                // })
              }
            },
          selHeyueTypeClick(id){
            if (id !== 10) { this.$emit('market', { 11: 'hk', 12: 'us', 2: 'index' }[id]); return }
            if(id != this.tabList2Idx){
              this.tabList2Idx = id
              if(id >= 10){
                this.page = 1
                this.zixuanList = []
                this.zx_keys_str = ''
                this.optionalList()
              }
            }
            
          },

  }
}
</script>
<style scoped>
.left-wrap { width: 24vw; height: 100%; }
.title { position: absolute; left: 0; top: 0; width: 100%; }
.market-tabs { display: flex; height: 36px; line-height: 36px; background: var(--theme-header); }
.market-tabs button { flex: 1; min-width: 0; padding: 0; border: 0; background: transparent; text-align: center; }
.market-tabs button.active { color: var(--theme-text); border-bottom: 2px solid var(--theme-accent); }
</style>

